import script from "./ChatUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatUser.vue?vue&type=script&lang=ts&setup=true"

import "./ChatUser.vue?vue&type=style&index=0&id=d423ef3e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d423ef3e"]])

export default __exports__